export const regexExpressions = {
  money: "/^[$]?[\\d,]+(?:\\.\\d{1,2})?$/",
  number: "/^[\\d,]+(?:\\.\\d{1,2})?$/",
  percent: "/^(?:100(?:\\.00?)?|\\d{1,2}(?:\\.\\d{1,2})?)%?$/",
};
export const dateFormats = ["MM/DD/YYYY", "M/D/YYYY", "M/D/YY", "MM/DD/YY"];
